module.exports = __webpack_public_path__ + "img/thumb-008-02.589d547f.png";